import { BaseFilter } from './base-filter.interface';

export interface FiltroRisorse extends BaseFilter {
  risorsa?: string | null;
  matricola?: string | null;
  periodoRiferimento?: string | null;
  idStatoPresaVisione?: number | null;
  dataPresaVisione?: string | null;
  idMotivazioneMancataPresaVisione?: number | null;
  responsabileGerarchico?: string | null;
  flagInadempiente?: boolean | null;
  richiesteDaApprovare?: boolean | null;
  hasRichiesteRettifica?: boolean | null;
  dataInvioSollecito?: string | null;
}

export const filtroRisorseVuoto: FiltroRisorse = {
  risorsa: null,
  matricola: null,
  periodoRiferimento: null,
  idStatoPresaVisione: null,
  dataPresaVisione: null,
  idMotivazioneMancataPresaVisione: null,
  responsabileGerarchico: null,
  flagInadempiente: null,
  richiesteDaApprovare: null,
  hasRichiesteRettifica: null,
  dataInvioSollecito: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export const filtroRisorseRplVuoto: FiltroRisorse = {
  risorsa: null,
  matricola: null,
  idStatoPresaVisione: null,
  responsabileGerarchico: null,
  flagInadempiente: true,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
}
